// extracted by mini-css-extract-plugin
module.exports = {"heading":"new-years-mileage-filter_heading___T1_h","sliderWrapper":"new-years-mileage-filter_sliderWrapper__myAGI"};